function deleteLocalStorageKeyWUS(key) {
    if (typeof localStorage !== 'undefined' && localStorage.getItem(key) !== null) {
      localStorage.removeItem(key);
    }
}

function hasParentWithClass(element, className) {
    while (element) {
        if (element.classList && element.classList.contains(className)) {
            return element;
        }
        element = element.parentElement;
    }
    return null;
}

function isValidDateWUS(date) {
    return date instanceof Date && !isNaN(date.getTime());
}

var wus = {}

let startY = 0;

wus.canRunInterval = null
wus.currentFloatingBIW = null
wus.alreadyUsedBIWProduct = false
wus.floatingBIWInterval = null
wus.startedFloatingBIW = false
wus.floatingBIWMode = ""
wus.currentProduct = null
wus.floatingBIWProduct = null
wus.currentMainProduts = null
wus.mainProductATCClicked = false

wus.log = function(data) {
    console.log("[WUS-INFO]", data)
}

wus.canRun = function() {
    var valid = true

    if (!document.getElementById("main")) {
        valid = false
    }

    if (!window.meta) {
        valid = false
    }

    return valid
}

wus.isMobileScreen = function() {
    return window.innerWidth < 700
}

wus.handleMenuItemsLeave = function() {
    if (wus.isMobileScreen()) {
        return
    }

    var menuItems = document.querySelectorAll("nav.header__link-list.wrap ul li [is=mega-menu-disclosure]")

    for (var i = 0; i < menuItems.length; i++) {
        menuItems[i].addEventListener('mouseleave', handleMouseLeave);
    }

    function handleMouseLeave(e) {
        var elem = e.target;
        elem.removeAttribute("open")

        var megaMenu = elem.querySelector(".mega-menu")
        megaMenu.style["opacity"] = "0"
    }
}

wus.handleAnnouncementBarLinks = function() {
    var abLinks = document.querySelectorAll(".announcement-bar__item p a")

    for (var i = 0; i < abLinks.length; i++) {
        var link = abLinks[i]
        
        if (link.getAttribute("href").includes("onelink")) {
            continue    
        }

        abLinks[i].addEventListener('click', function(e) {
            e.preventDefault();
        });
    }
}

wus.startPlaceholderTyping = function(inputElem, textList, prefix) {
    let textIndex = 0;
    let blinkInterval;
  
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  
    function isInputFocused() {
        return document.activeElement === inputElem;
    }

    function startBlinkingCursor(baseText) {
        let visible = true;
        if (isInputFocused()) {
            inputElem.placeholder = baseText;
            return;
        }
    
        blinkInterval = setInterval(() => {
            if (isInputFocused()) {
                inputElem.placeholder = baseText;
                return;
            }
        
            inputElem.placeholder = baseText + (visible ? "|" : "");
            visible = !visible;
        }, 200);
    }
  
    function stopBlinkingCursor() {
      clearInterval(blinkInterval);
    }
  
    async function typeText(suffix) {
        for (let i = 0; i <= suffix.length; i++) {
            inputElem.placeholder = prefix + suffix.slice(0, i);
            await sleep(100);
        }
    }
  
    async function deleteText(suffix) {
        for (let i = suffix.length; i >= 0; i--) {
            inputElem.placeholder = prefix + suffix.slice(0, i);
            await sleep(50);
        }
    }
  
    async function loop() {
        while (true) {
            const suffix = textList[textIndex];
            await typeText(suffix);
            startBlinkingCursor(prefix + suffix);
            await sleep(1000); 
            stopBlinkingCursor();
            await deleteText(suffix);
            startBlinkingCursor(prefix);
            await sleep(1000);
            stopBlinkingCursor();
            textIndex = (textIndex + 1) % textList.length;
        }
    }
  
    loop();
}

wus.handleSearchPlaceholder = function() {
    let inputElem = document.querySelector("input[name='q']");

    if (!inputElem) {
        setTimeout(function() {
            wus.handleSearchPlaceholder();
        }, 1000)
        return
    }

    let searchPlaceholder = "Search for "

    let textList = [
        "...",
        "Lifestyle Shoes",
        "Running Shoes",
        "Training Shoes",
        "T-shirt",
        "Racket",
        "Slides",
        "Soccer Shoes",
        "Shorts",
        "Pants",
        "Basketball Shoes",
        "Tennis Shoes",
        "Whey Protein",
        "Leggings",
        "Tank Top",
        "Tracksuit",
        "Duffle Bag",
        "Clog",
        "Socks",
        "Backpack",
        "Swimwear"
    ]

    if (wus.isRTL()) {
        textList = [
            "...",
            "حذاء للاستخدام اليومي",
            "حذاء جري",
            "حذاء تدريب",
            "تيشيرت",
            "مضرب",
            "شباشب",
            "حذاء كرة القدم",
            "شورتات",
            "بنطلونات",
            "حذاء كرة سلة",
            "حذاء تنس",
            "واي بروتين",
            "ليجنز",
            "تانك توب",
            "بدلة رياضية",
            "شنطة دافل",
            "كلوجز",
            "شرابات",
            "شنطة ظهر",
            "ملابس سباحة"
        ]

        searchPlaceholder = "ابحث عن "
    }

    wus.startPlaceholderTyping(inputElem, textList, searchPlaceholder)
}
  

wus.handleAccesoriesLink = function() {
    var elem = document.querySelector('a[href*="custom/accessories"]')
    var elemSummary = document.querySelector('[data-url*="custom/accessories"]')
    
    if (elem) {
        elem.href = "#"

        elem.addEventListener('click', function(e) {
            e.preventDefault();
        });
    }

    if (elemSummary) {
        elemSummary.removeAttribute("data-url")
    }
}

wus.fetchProductJSON = async function(productHandle) {
    try {
        let url = "/products/" + productHandle + ".json"
        const response = await fetch(url);
        if (!response.ok) {
            return null
        }
        const data = await response.json();
        return data
    } catch (error) {
        return null
    }
}

wus.getProductHandle = function() {
    let elem = document.getElementById("wus-biw-product-handle")
    let handle = null

    if (elem) {
        handle =  elem.getAttribute("data-product-handle")
    }

    return handle
}

wus.getProductDirectMatchHandle = function() {
    let elem = document.getElementById("wus-biw-direct-match")
    let handle = null

    if (elem) {
        handle = elem.getAttribute("data-direct-match")
    }

    return handle
}

wus.fetchProductMatch = async function(productDirectMatch) {
    let products = await wus.fetchProductsByType(productDirectMatch, false, true)
    if (!(products !== null && products.length > 0)) {
        return null
    }
    return products[0]
}

// TO BE REMOVED
wus.getProductsRecomBIW = async function() {
    try {
        let url = document.getElementById("wus-biw-recoms").getAttribute("data-url")
        const response = await fetch(url);
        if (!response.ok) {
            return null
        }
        const data = await response.json();
        return data
    } catch (error) {
        return null
    }
}

wus.getSuggestedProductByType = async function(productType, gender, sport, vendor, productObj) {
    let products = await wus.fetchProductsByTypeSearch(productType, true, gender, sport, vendor, productObj)

    // if (!(products !== null && products.length > 0)) {
    //     return null;
    // }

    if (!(products !== null && products.length > 0)) {
        //products = await wus.fetchProductsByTypeSearch(productType, true)
        if (!(products !== null && products.length > 0)) {
            return null
        }
    }

    let product = products[Math.floor(Math.random() * products.length)]
    return product
}

wus.fetchProductsByType = async function(productType, includeVendor, onlySKU) {
    try {
        let query = productType;

        //let vendor = document.getElementById("wus-biw-product-vendor").getAttribute("data-product-vendor")
        let vendor = ""

        if (wus.floatingBIWProduct && wus.floatingBIWProduct.vendor) {
            vendor = wus.floatingBIWProduct.vendor
        }

        if (typeof vendor === "string" && vendor.length > 0) {
            if (includeVendor) {
                query = vendor + " " + productType
            }
        }

        let url = "/search/suggest.json?q=" + query + "&resources[type]=product&resources[options][unavailable_products]=hide"

        if (onlySKU) {
            url += "&resources[limit]=1&resources[options][fields]=variants.sku"
        } else {
            url += "&resources[limit]=10&resources[options][fields]=product_type,vendor,variants.title"
        }
        

        const response = await fetch(url);
        if (!response.ok) {
            return null
        }
        const data = await response.json();

        if (!(data.resources && data.resources.results && data.resources.results.products)) {
            return null
        }

        return data.resources.results.products
    } catch (error) {
        console.log(error)
        return null
    }
}

wus.getImageSrcWithVersion = function(currentImageSrc) {
    const url = currentImageSrc

    const [baseUrl, queryString] = url.split('?');

    let desiredParams = [];

    if (queryString) {
        const params = queryString.split('&');

        desiredParams = params.filter(param => param.startsWith('v='));
    }

    return desiredParams.length > 0 ? `${baseUrl}?${desiredParams.join('&')}` : baseUrl;
}

wus.handlePricesFromHTML = function(priceElem) {
    priceElem.querySelector("span").remove()
    const priceNumbers = priceElem.textContent.trim().replace(/[^\d.-]/g, '');
    return parseFloat(priceNumbers).toString();
}

wus.fetchProductsByTypeSearch = async function(productType, includeVendor, gender, sport, vendor, productObj) {
    try {
        let paramsArray = []

        let searchQueryArr = []
        let searchQuery = ""

        var specialBrands = ["nike", "adidas", "on", "asics", "wilson", "converse", "crocs", "babolat"]

        if (includeVendor) {
            var isValid = true
            if (typeof vendor === "string") {
                if (productType.toLowerCase() === "socks" && 
                      sport && sport.toLocaleLowerCase() === "football" &&
                      vendor.toLocaleLowerCase() === "adidas") {
                    isValid = false
                }

                if (isValid) {
                    searchQueryArr.push(vendor)
                }
            } else {
                if (productType.toLowerCase() === "socks") {
                    if (specialBrands.includes(productObj.vendor.toLocaleLowerCase())) {
                        searchQueryArr.push("adidas")
                    }
                }
            }
        }

        if (typeof sport === "string") {
            searchQueryArr.push(sport)
        }

        if (typeof gender === "string" && gender.length > 0) {
            if (gender !== "Unisex" && gender !== "Kids") {
                searchQueryArr.push(gender)
            }
        }

        if (productType.toLowerCase() === "socks" && wus.isLifeStyleProduct(productObj)) {
            searchQueryArr.push("everyday thing")
        }

        searchQueryArr.push(productType)

        searchQuery = searchQueryArr.join(" ");

        //console.log(searchQuery)

        paramsArray.push("q=" + searchQuery)
        
        paramsArray.push("type=product")
        paramsArray.push("sort_by=relevance")

        paramsArray.push("filter.p.product_type=" + productType)
        paramsArray.push("filter.v.availability=1")

        if (typeof gender === "string" && gender.length > 0) {
            if (gender === "Kids") {
                if (productType.toLowerCase() !== "socks") {
                    paramsArray.push("filter.p.m.my_fields.gender=" + gender)
                }
            }

            if (window.wus.currentProduct && window.wus.currentProduct.product_type === "Hijab") {
                paramsArray.push("filter.p.m.my_fields.gender=Women")
            }
        }

        let params = paramsArray.join("&")

        let url = "/search?" + params

        const response = await fetch(url);
        
        //console.log(url)

        if (!response.ok) {
            return null
        }
        
        const htmlData = await response.text();

        if (!(typeof htmlData === "string" && htmlData.length > 0)) {
            return null
        }

        const parser = new DOMParser();
        const htmlObj = parser.parseFromString(htmlData, 'text/html');

        let productCardsElems = htmlObj.querySelectorAll("product-card");

        let products = []

        for (var i = 0; i < productCardsElems.length; i++) {
            var productCardElem = productCardsElems[i]
            
            var product = {}

            let handle = productCardElem.getAttribute("handle")
            let productId = productCardElem.getAttribute("product-id")

            let primaryImage = productCardElem.querySelector(".product-card__image--primary")
            let secondaryImage = productCardElem.querySelector(".product-card__image--secondary")
            let vendorElem = productCardElem.querySelector(".product-card__info a.text-xs.link-faded")
            let titleElem = productCardElem.querySelector(".product-card__title a")
            let tagsElem = productCardElem.querySelectorAll(".product-card__badge-list .badge")
            let priceElem = productCardElem.querySelector("sale-price")
            let comparePriceElem = productCardElem.querySelector("compare-at-price")

            product.handle = handle
            product.id = productId
            product.tags = []

            if (primaryImage) {
                product.image = wus.getImageSrcWithVersion(primaryImage.getAttribute("src"))
            }

            if (secondaryImage) {
                product.secondImage = wus.getImageSrcWithVersion(secondaryImage.getAttribute("src"))
            }

            if (vendorElem) {
                product.vendor = vendorElem.innerHTML.trim()
            }

            if (titleElem) {
                product.title = titleElem.innerHTML.trim()
            }

            if (tagsElem.length > 0) {
                for (var y = 0; y < tagsElem.length; y++) {
                    product.tags.push(tagsElem[y].innerHTML)
                }
            }

            if (comparePriceElem) {
                product.compare_at_price_max = wus.handlePricesFromHTML(comparePriceElem);
            } else {
                product.compare_at_price_max = "0.00"
            }

            product.price_max = wus.handlePricesFromHTML(priceElem);
            products.push(product)

            if (products.length >= 4) {
                break
            }
        }

        return products
    } catch (error) {
        console.log(error)
        return null
    }
}

wus.handleProductBIWFloating = async function(floatingElem) {   
    document.querySelector("html").classList.add("wus-biw-f-here")
    wus.currentFloatingBIW = floatingElem
}

wus.monitorATCBIW = function() {
    var elem = document.querySelector(".quick-buy-drawer.show-close-cursor .quick-buy-drawer__info .banner--success")

    if (elem) {
        wus.openFloatingBIW()
    } else {
        wus.closeFloatingBIW()
    }
}

wus.monitorGlobalBIW = function() {
    if (wus.floatingBIWInterval) {
        return
    }

    wus.floatingBIWInterval = setInterval(function() {
        wus.monitorATCBIW()
    }, 10)
}

wus.openFloatingBIW = function() {
    if (!wus.currentFloatingBIW) {
        return
    }

    if (wus.currentFloatingBIW.classList.contains("biw-opened")) {
        return
    }

    if (wus.alreadyUsedBIWProduct) {
        return
    }

    if (!wus.currentFloatingBIW.classList.contains("wus-biw-has-products")) {
        return
    }

    wus.currentFloatingBIW.classList.remove("biw-closed")
    wus.currentFloatingBIW.classList.add("biw-opened")

    wus.currentFloatingBIW.style.setProperty("display", "flow-root", "important")
    setTimeout(function() {
        if (wus.isMobileScreen()) {
            var drawer = document.querySelector(".quick-buy-drawer.show-close-cursor")
            var bottom = drawer.clientHeight - 30
            wus.currentFloatingBIW.style.setProperty("bottom", bottom + "px");
        }
        
        wus.currentFloatingBIW.style.setProperty("opacity", "1")
    }, 500)
}

wus.closeFloatingBIW = function() {
    if (!wus.currentFloatingBIW) {
        return
    }

    if (!wus.currentFloatingBIW.classList.contains("biw-opened")) {
        return
    }

    wus.currentFloatingBIW.classList.remove("biw-opened")
    wus.currentFloatingBIW.style.setProperty("opacity", "0")

    wus.currentFloatingBIW.classList.remove("wus-biw-has-products")

    setTimeout(function() {
        wus.currentFloatingBIW.style.setProperty("display", "none", "important")
        wus.startedFloatingBIW = false
        wus.currentFloatingBIW.classList.add("biw-closed")
        wus.floatingBIWProduct = null
    }, 200)
}

wus.isFloatingBIWOpen = function() {
    if (wus.currentFloatingBIW && wus.currentFloatingBIW.classList.contains("biw-opened")) {
        return true
    }

    return false
}

wus.handleProductsBIW = async function() {
    var biwElems = document.querySelectorAll(".wus-biw-main");

    if (wus.isProductPage()) {
        let productHandle = wus.getProductHandle()
        for (var i = 0; i < biwElems.length; i++) {
            var elem = biwElems[i]
            wus.handleProductBuyItWith(elem, productHandle, true)
        }
    }

    if (biwElems.length > 0) {
        wus.monitorGlobalBIW()
    }

    function handleHorQuickATC(quickElem) {
        wus.alreadyUsedBIWProduct = false
        var elem = document.querySelector(".shopify-section--wus-biw-f .wus-biw-main");
        
        if (!elem) {
            return
        }

        var productCardElem = quickElem.closest(".horizontal-product")
        var quickDrawerElem = productCardElem.querySelector("quick-buy-drawer")

        if (!quickDrawerElem) {
            return
        }

        var productHandle = quickDrawerElem.getAttribute("handle")

        if (typeof productHandle === "string" && productHandle.includes("?")) {
            var productHandleArr = productHandle.split("?")
            if (typeof productHandleArr[0] === "string") {
                productHandle = productHandleArr[0]
            }
        }
        
        wus.handleProductBuyItWith(elem, productHandle, false)
    }

    function handleBiwNavClick(elem) {
        var eventValue = ""
        try {
            var productCardElem = elem.closest("product-card.product-card")
            var productHandle = productCardElem.getAttribute("handle")
            eventValue = productHandle
        } catch(e) {
            console.error(e)
            eventValue = ""
        }
        
        wus.sendEventGA("wus_biw_nav", "wus_biw", "", eventValue);
    }

    function handleQuickATC(quickElem) {
        var biwFloatingElem = quickElem.closest(".shopify-section--wus-biw-f")
        if (biwFloatingElem) {
            wus.alreadyUsedBIWProduct = true
            setTimeout(function() {
                var closeElem = document.querySelector(".quick-buy-drawer.show-close-cursor")
                if (closeElem) {
                    closeElem.shadowRoot.querySelector("[part='outside-close-button']").click()
                }
            }, 100);

            try {
                var productCardElem = quickElem.closest("product-card.product-card")
                var productHandle = productCardElem.getAttribute("handle")

                var eventValue = productHandle

                if (wus.floatingBIWProduct && typeof wus.floatingBIWProduct.handle === "string") {
                    //eventValue += "__" + wus.floatingBIWProduct.handle
                }

                wus.sendEventGA("wus_biw_qatc", "wus_biw", "", eventValue);
            } catch(e) {
                console.error(e)
            }
            
            return
        }
        
        wus.alreadyUsedBIWProduct = false

        var elem = document.querySelector(".shopify-section--wus-biw-f .wus-biw-main");
        
        if (!elem) {
            return
        }

        var productCardElem = quickElem.closest("product-card.product-card")
        var productHandle = productCardElem.getAttribute("handle")
        
        wus.handleProductBuyItWith(elem, productHandle, false)
    }

    function handleBigATC() {
        wus.alreadyUsedBIWProduct = false
        var elem = document.querySelector(".shopify-section--wus-biw-f .wus-biw-main");
        if (!elem) {
            return
        }

        let productHandle = wus.getProductHandle()
        wus.handleProductBuyItWith(elem, productHandle, true)
    }
    
    document.addEventListener("click", function(e) {
        if (e.target && e.target.closest(".product-card .product-card__quick-buy")) {
            handleQuickATC(e.target)
            return
        }

        if (e.target && 
            e.target.tagName.toLowerCase() === "a" &&
            e.target.closest(".shopify-section--wus-biw-f .product-card .product-card__info")) {
            handleBiwNavClick(e.target)
            return
        }

        if (e.target && 
            (e.target.tagName.toLowerCase() === "a" || e.target.tagName.toLowerCase() === "img") &&
            e.target.closest(".shopify-section--wus-biw-f .product-card .product-card__figure")) {
            handleBiwNavClick(e.target)
            return
        }
        
        if (e.target && e.target.closest(".product-info__buy-buttons buy-buttons.buy-buttons")) {
            handleBigATC()
            return
        }

        if (e.target && e.target.closest(".horizontal-product .horizontal-product__info .horizontal-product__cta")) {
            handleHorQuickATC(e.target)
            return
        }
    })
}

wus.handleProductCart

wus.formatPrice = function(price) {
    const formattedNumber = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(price);

    return formattedNumber
}

wus.getGenderFromProductObj = function(product) {
    let gender = ""

    const kidsArray = ["Kids", "Boys", "Girls", "Youth"]

    if (product.tags) {
        let tags = product.tags.split(", ")
        if (kidsArray.some(item => tags.includes(item))) {
            gender = "Kids"
        } else if (tags.includes("Men") && tags.includes("Women")) {
            gender = "Unisex"
        } else if (tags.includes("Men")) {
            gender = "Men"
        } else if (tags.includes("Women")) {
            gender = "Women"
        }
    }

    return gender
}

wus.getSportFromProductObj = function(product) {
    let itemRet = ""

    const sportsArray = ["football", "basketball", "tennis", "PADEL"]

    if (product.tags) {
        let tagsArr = product.tags.split(", ")
        itemRet = tagsArr.find(item => 
            sportsArray.some(otherItem => otherItem.toLowerCase() === item.toLowerCase())
        );
    }

    return itemRet
}

wus.isLifeStyleProduct = function(product) {
    if (product.tags) {
        let tagsArr = product.tags.toLowerCase().split(", ")
        if (tagsArr.includes("lifestyle")) {
            return true
        }
    }

    return false
}

wus.getVendorFromProductObj = function(product) {
    let itemRet = ""

    const vendorsArray = ["nike", "adidas"]

    if (product.vendor) {
        itemRet = vendorsArray.find(item => item.toLowerCase() === product.vendor.toLowerCase()) || null;
    }

    return itemRet
}

wus.handleProductBuyItWith = async function(biwElem, productHandle, isMainProduct) {
    if (typeof productHandle !== "string") {
        return
    }

    let viewMode = biwElem.getAttribute("data-product-vm")
    let secionId = biwElem.getAttribute("data-section-id")

    let productsRecomBIW = await wus.getProductsRecomBIW()
    let productJSON = await wus.fetchProductJSON(productHandle)

    if (!(productJSON.product && productJSON.product.product_type)) {
        return
    }

    if (isMainProduct) {
        window.wus.currentProduct = productJSON.product
    } else {
        wus.floatingBIWProduct = productJSON.product
    }
    
    let productRecoms = productsRecomBIW[productJSON.product.product_type]
    let gender = wus.getGenderFromProductObj(productJSON.product)
    let sport = wus.getSportFromProductObj(productJSON.product)
    let vendor = wus.getVendorFromProductObj(productJSON.product)
    let products = []

    var isShoesProduct = false

    if (productJSON.product.product_type && productJSON.product.product_type.toLowerCase().includes("shoes")) {
        isShoesProduct = true
    }
    
    let productDirectMatch = wus.getProductDirectMatchHandle()

    if (!Array.isArray(productRecoms)) {
        productRecoms = []
    }

    var promises = []

    if (typeof productDirectMatch === "string" && productDirectMatch.length > 0) {
        promises.push(wus.fetchProductMatch(productDirectMatch))
    }

    for (var recom of productRecoms) {
        promises.push(wus.getSuggestedProductByType(recom, gender, sport, vendor, productJSON.product))
    }

    if (Array.isArray(wus.currentMainProduts) && isMainProduct) {
        products = wus.currentMainProduts    
    } else {
        const results = await Promise.all(promises);
        products.push(...results)
    }

    products.sort((a, b) => {
        const priceA = a && a.price_max ? parseFloat(a.price_max) : Infinity;
        const priceB = b && b.price_max ? parseFloat(b.price_max) : Infinity;
      
        return priceA - priceB;
    });

    if (isShoesProduct) {
        var extraShoesProducts = ["0kfi1mvb"];

        var extraPromises = []
        var finalExtraProducts = []

        for (var extraShoesProduct of extraShoesProducts) {
            extraPromises.push(wus.fetchProductMatch(extraShoesProduct))
        }

        var extraProducts = await Promise.all(extraPromises)

        products = [...extraProducts, ...products];
    }

    let singleProdcutCardHTML = window.WUS_BIW_TEMPLATE["wus-single-product-biw-card"]

    if (viewMode === "v") {
        singleProdcutCardHTML = window.WUS_BIW_TEMPLATE["wus-single-product-biw-code"]
    }

    let allProductsHTML = ""
    
    if (!Array.isArray(products)) {
        return
    }

    if (products.filter(item => item !== null).length <= 2) {
        biwElem.classList.add("wus-biw-remove-more")
    }

    for (var suggestedProduct of products) {
        if (!suggestedProduct) {
            continue
        }

        let pHTML = singleProdcutCardHTML
        
        pHTML = pHTML.replace(new RegExp("P_IMG", 'g'), suggestedProduct.image)
        pHTML = pHTML.replace(new RegExp("P_HANDLE", 'g'), suggestedProduct.handle)
        pHTML = pHTML.replace(new RegExp("P_PID", 'g'), suggestedProduct.id)
        pHTML = pHTML.replace(new RegExp("P_TITLE", 'g'), suggestedProduct.title)
        pHTML = pHTML.replace(new RegExp("TEMP_ID", 'g'), secionId)
        pHTML = pHTML.replace(new RegExp("P_VENDOR", 'g'), suggestedProduct.vendor)

        let compareAtPrice = suggestedProduct.compare_at_price_max
        let currentPrice = suggestedProduct.price_max
        
        let compareAtPriceFloat = parseFloat(compareAtPrice)

        if (!isNaN(compareAtPriceFloat) && compareAtPriceFloat > 0) {
            pHTML = pHTML.replace(new RegExp("P_S_PRICE_STYLE", 'g'), "")
            pHTML = pHTML.replace(new RegExp("P_O_PRICE_CLASS", 'g'), "line-through")
            pHTML = pHTML.replace(new RegExp("P_S_PRICE", 'g'), wus.formatPrice(currentPrice))
            pHTML = pHTML.replace(new RegExp("P_O_PRICE", 'g'), wus.formatPrice(compareAtPrice))
        } else {
            pHTML = pHTML.replace(new RegExp("P_S_PRICE_STYLE", 'g'), "display: none;")
            pHTML = pHTML.replace(new RegExp("P_O_PRICE_CLASS", 'g'), "")
            pHTML = pHTML.replace(new RegExp("P_O_PRICE", 'g'), wus.formatPrice(currentPrice))
        }

        if (viewMode === "h") {
            if (suggestedProduct.tags && Array.isArray(suggestedProduct.tags) && suggestedProduct.tags.length > 0) {
                const isExpress = suggestedProduct.tags.map(item => item.toLowerCase()).includes("express");
                let expressDisplayValue = "none"
                if (isExpress) {
                    expressDisplayValue = "flex"
                }

                pHTML = pHTML.replace(new RegExp("EXPRESS_DISPLAY", 'g'), expressDisplayValue)   
            }
        }

        allProductsHTML += pHTML
    }

    let wusRecommendationsElem = biwElem.querySelector("wus-product-recommendations")

    if (!wusRecommendationsElem) {
        return
    }

    if (allProductsHTML === "") {
        return
    }

    if (viewMode === "v") {
        let listElem = wusRecommendationsElem.querySelector(".horizontal-product-list")
        listElem.innerHTML = allProductsHTML
    } else {
        let carouselViewHTML = window.WUS_BIW_TEMPLATE["wus-biw-carousel-code"]
        carouselViewHTML = carouselViewHTML.replace(new RegExp("TEMP_ID", 'g'), secionId)
        carouselViewHTML = carouselViewHTML.replace("PRODUCT_LIST", allProductsHTML)
        wusRecommendationsElem.innerHTML = carouselViewHTML

        var parentElement = hasParentWithClass(wusRecommendationsElem, "shopify-section--wus-biw-f")

        if (parentElement !== null) {
            parentElement.classList.remove("wus-biw-has-products")
            if (allProductsHTML !== "") {
                parentElement.classList.add("wus-biw-has-products")
            }
            wus.handleProductBIWFloating(parentElement)
        }
    }

    biwElem.style["display"] = "block"
    wus.handleLoadMoreBIW(biwElem)
}

wus.handleLoadMoreBIW = function(biwElem) {
    let loadMoreElem = biwElem.querySelector(".load-more-biw")
    if (!loadMoreElem) {
        return
    }

    loadMoreElem.onclick = function() {
        biwElem.classList.toggle('biw-show-all')
    }
}

wus.handleChatSupportPage = function() {
    if (!(window.location.href.indexOf("pages/chat-support") > -1)) {
        return
    }

    if (!window.zE) {
        setTimeout(function() {
            wus.handleChatSupportPage()
        }, 50)
        return
    }

    let launcherElem = document.getElementById("launcher");

    if (!launcherElem) {
        setTimeout(function() {
            wus.handleChatSupportPage()
        }, 50)

        return
    }

    window.zE('messenger', 'open');
}

wus.closeMobileMenu = function() {
    if (!wus.isMobileScreen()) {
        return
    }

    var sideMenuElem = document.querySelector("#header-sidebar-menu")
    if (!sideMenuElem) {
        return
    }

    sideMenuElem.shadowRoot.querySelector("[part='overlay']").click()
}

wus.sendEventGA = function(name, category, label, value) {
    if (typeof gtag !== "function") {
        return
    }

    try {
        gtag('event', name, {
            'event_category': category || "",
            'event_label': label || "",
            'value': value || ""
        });
    } catch(e) {
        console.error(e)
    }
}

wus.handleLangButton = function() {
    var elem = document.querySelector("#wus-lang-selector-mobile");
    if (elem) {
        elem.addEventListener("click", function(e) {
            e.preventDefault()
            let mobileElemButton = document.querySelector("header button[aria-controls*='popover-localization-form-locale']")
            if (mobileElemButton) {
                wus.closeMobileMenu()
                mobileElemButton.click()
            }
        })
    }
}

wus.handleMenuLangButton = function() {
    let elem = document.querySelector("header button[aria-controls*='popover-localization-form-locale']")
    if (elem) {
        elem.addEventListener("click", function(e) {
            wus.closeMobileMenu();
        })
    }
}

wus.handleLanguage = function() {
    wus.handleLangButton();
    wus.handleMenuLangButton();
    function redirectLang(langCode) {
        var supportedLangs = ["ar"]
        const urlObject = new URL(window.location.href);
        var currentPathname = urlObject.pathname

        for (var i = 0; i < supportedLangs.length; i++) {
            var lang = supportedLangs[i]
            var singleSlash = "/" + lang
            var multipleSlash = singleSlash + "/"
            if (currentPathname === singleSlash || currentPathname.startsWith(multipleSlash)) {
                currentPathname = currentPathname.replace("/" + lang, "")
                break;
            }
        }

        if (langCode !== "en") {
            window.location.pathname = '/' + langCode + currentPathname;
        } else {
            window.location.pathname = currentPathname
        }
    }

    function checkLangOnStart() {
        let htmlElem = document.documentElement
        let currentLang = htmlElem.getAttribute("lang")

        let savedLang = localStorage.getItem("WUS_LAST_USED_LANG")

        if (typeof savedLang === "string" && savedLang.length > 0) {
            if (savedLang !== currentLang) {
                redirectLang(savedLang)
            }
        }
        
        
        let langButtons = document.querySelectorAll(".popover-listbox__option[name='locale_code']")

        for (var i = 0; i < langButtons.length; i++) {
            var langButton = langButtons[i]
            langButton.addEventListener("click", function() {
                let value = this.getAttribute("value")
                if (typeof value === "string") {
                    localStorage.setItem("WUS_LAST_USED_LANG", value)
                }
            })
        }
    }

    checkLangOnStart()
    
    if (wus.isMobileScreen()) {
        let mobileElemButton = document.querySelector(".navigation-drawer .panel-footer__localization-wrapper button[aria-controls*='popover-localization-form-locale']")
        if (mobileElemButton) {
            mobileElemButton.addEventListener("click", function() {
                wus.closeMobileMenu()
            })
        }    
    }
}

wus.handleStockChecked = function() {
    try {
        var elems = document.querySelectorAll('input[name="filter.v.availability"]');
        
        if (!elems) {
            return
        }

        if (elems.length === 0) {
            return
        }

        for (var i = 0; i < elems.length; i++) {
            var elem = elems[i];
            elem.checked = true
        }
    } catch(e) {
        console.error(e)
    }
    
}

wus.handleDisableVendorLink = function() {
    var elems = document.querySelectorAll('.wus-vendor-link');
        
    if (!elems) {
        return
    }

    if (elems.length === 0) {
        return
    }

    for (var i = 0; i < elems.length; i++) {
        var elem = elems[i];
        elem.addEventListener('click', function(event) {
            event.preventDefault(); // Disable the default action
        });
    }
}

wus.showNewsletterButton = function() {
    var elem = document.getElementById("wus-newsletter-button")
    if (!elem) {
        return
    }

    setTimeout(function() {
        elem.classList.add("show");
    }, 1500)
}

wus.handleNewsletterButton = function() {
    var elem = document.getElementById("wus-newsletter-button")
    var nlElem = document.getElementById("newsletter-drawer")
    
    if (!elem) {
        return
    }

    if (!nlElem) {
        return
    }

    elem.onclick = function() {
        if (nlElem.classList.contains("show-close-cursor")) {
            return;
        }
        window.showNewsLetterWUS()
    }
}

wus.handleEndlessCarousels = function() {
    var elems = document.querySelectorAll(".wus-endless-carousel-wrapper");
    for (var elem of elems) {
        wus.handleEndlessCarousel(elem);
    }
}

// wus.handleEndlessCarousel = function(elem) {
//     let isResuming = false;
//     let isResumingTimeout = null;
//     var isDraggable = elem.classList.contains("wus-endless-carousel-draggable-true");

//     function enableCarouselDrag(carousel) {
//         let parent = carousel.closest(".wus-endless-carousel-container");
//         let items = carousel.querySelectorAll(".wus-endless-carousel-item");
//         let firstMobileItem = carousel.querySelectorAll(".wus-endless-carousel-item-mobile")[0];
//         let firstDesktopItem = carousel.querySelectorAll(".wus-endless-carousel-item-desktop")[0];

//         let itemsLength = items.length / 4;
        
//         let firstElem = firstDesktopItem;

//         if (wus.isMobileScreen()) {
//             firstElem = firstMobileItem;
//         }

//         let itemWidth = carousel.clientWidth / itemsLength;

//         if (firstElem) {
//             itemWidth = firstElem.clientWidth;
//         }

//         let itemsPerScreen = window.innerWidth / itemWidth;
//         let carouselWidth = carousel.clientWidth / 2;
        
//         let maxTranslate = carouselWidth - (itemsPerScreen * itemWidth);
//         console.log(itemsLength, itemWidth, maxTranslate);
//         const isFromLeft = carousel.classList.contains("from-left");

//         if (isFromLeft) {
//             maxTranslate = -maxTranslate;
//         }

//         let isDown = false;
//         let startX;
//         let currentTransform = 0;
    
//         function getTranslateX() {
//           const style = window.getComputedStyle(carousel).transform;
//           if (style === 'none') return 0;
//           const matrix = new DOMMatrix(style);
//           let translate = matrix.m41;

//           return translate;
//         }
    
//         function pauseAnimation() {
//           currentTransform = getTranslateX();
//           console.log("currentTransform", currentTransform);
//           carousel.style.transform = `translateX(${currentTransform}px)`;
//           carousel.style.animation = 'none';
//         }
    
//         function startDrag(x) {
//           isDown = true;
//           startX = x;
//           clearTimeout(isResumingTimeout);
//           pauseAnimation();
//           carousel.classList.add('dragging');
//         }
    
//         function moveDrag(x) {
//           if (!isDown) return;
//           clearTimeout(isResumingTimeout);
//           const walk = x - startX;
//           let newTransform = currentTransform + walk;
//           if (isFromLeft) {
//             if (newTransform < maxTranslate) {
//               newTransform = maxTranslate;
//             }
//             if (newTransform > 0) {
//                 newTransform = 0;
//             }
//           } else {
//             if (newTransform > maxTranslate) {
//               newTransform = maxTranslate;
//             }
//             if (newTransform < 0) {
//                 newTransform = 0;
//             }
//           }
//           carousel.style.transform = `translateX(${newTransform}px)`;
//         }
    
//         function endDrag(x) {
//           if (!isDown) return;
//           isDown = false;
//           const walk = x - startX;
//           currentTransform += walk;
//           resumAnimation();
//         }

//         function resumAnimation() {
//             if (isResuming) {
//                 return;
//             }

//             isResumingTimeout = setTimeout(() => {
//                 isResuming = true;

//                 carousel.style.transition = "transform 0.2s ease-in-out";
//                 carousel.style.transform = `translateX(0px)`;

//                 setTimeout(() => {
//                     carousel.classList.remove('dragging');
//                     carousel.style.removeProperty("transform");
//                     carousel.style.removeProperty("animation");
//                     carousel.style.removeProperty("transition");
//                     isResuming = false;
//                 }, 200);
//             }, 2000);
//         }
    
//         carousel.addEventListener('mousedown', e => startDrag(e.pageX));
//         carousel.addEventListener('mousemove', e => moveDrag(e.pageX));
//         carousel.addEventListener('mouseup', e => endDrag(e.pageX));
//         carousel.addEventListener('mouseleave', e => endDrag(e.pageX));
    
//         carousel.addEventListener('touchstart', e => startDrag(e.touches[0].clientX), { passive: true });
//         carousel.addEventListener('touchmove', e => moveDrag(e.touches[0].clientX), { passive: true });
//         carousel.addEventListener('touchend', e => endDrag(e.changedTouches[0].clientX));

//         window.addEventListener("scroll", function() {
//             resumAnimation();
//         });
//     }

//     if (isDraggable) {
//         enableCarouselDrag(elem);
//     }
// }

wus.handleEndlessCarousel = function(elem) {
    let isResuming = false;
    let resumeTimeout = null;
    const isDraggable = elem.classList.contains("wus-endless-carousel-draggable-true");
  
    function enableCarouselDrag(carousel) {
        const parent = carousel.closest(".wus-endless-carousel-container");
        const isFromLeft = carousel.classList.contains("from-left");
    
        let currentTransform = 0;
        let isScrolling = false;
    
        function getTranslateX() {
            const style = window.getComputedStyle(carousel).transform;
            if (style === 'none') return 0;
            const matrix = new DOMMatrix(style);
            return matrix.m41;
        }
    
        function pauseAnimationToScroll() {
            if (carousel.classList.contains("scrolling")) {
                return;
            }

            carousel.classList.add("scrolling");
            currentTransform = getTranslateX();
            carousel.style.animation = 'none';
            // carousel.style.transform = `translateX(${currentTransform}px)`;
            carousel.style.transform = `translateX(0px)`;
    
            // enable scroll
            parent.style.overflowX = 'auto';
            // parent.scrollLeft = isFromLeft
            //   ? parent.scrollWidth - parent.clientWidth + currentTransform
            //   : -currentTransform;

            parent.scrollLeft = Math.abs(currentTransform);
        }
    
        function resumeAnimationFromScroll() {
            if (isResuming) return;
            isResuming = true;
    
            const delay = 5_000;
    
            resumeTimeout = setTimeout(() => {
                parent.scrollTo({
                    left: 0,
                    behavior: 'smooth'
                });

                parent.style.overflowX = 'hidden';
                carousel.style.transition = 'transform 0.4s ease-out';
                carousel.style.transform = 'translateX(0px)';

                setTimeout(() => {
                    carousel.style.removeProperty('transform');
                    carousel.style.removeProperty('animation');
                    carousel.style.removeProperty('transition');
                    isResuming = false;
                    carousel.classList.remove("scrolling");
                }, 400);
            }, delay);
        }
    
        function cancelResumeTimer() {
            clearTimeout(resumeTimeout);
            resumeTimeout = null;
            isResuming = false;
        }
    
        // Track when user interacts
        function startScrollMode(x) {
            pauseAnimationToScroll();
            cancelResumeTimer();
        }
    
        // Use native scroll events to detect user activity
        parent.addEventListener('scroll', () => {
            cancelResumeTimer();
            resumeAnimationFromScroll();
        });
    
        // Mouse
        carousel.addEventListener('mousedown', e => startScrollMode(e.pageX));
    
        // Touch
        carousel.addEventListener('touchstart', e => startScrollMode(e.touches[0].clientX), { passive: true });
    }
  
    if (isDraggable) {
      enableCarouselDrag(elem);
    }
};
  
wus.handleAnivLogo = function() {
    var elem = document.getElementById("wus-aniv-logo-container");
    if (!elem) {
        return;
    }

    function checkAnivLogo() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
      
        const scrollPercent = (scrollTop + windowHeight) / documentHeight;
      
        if (scrollPercent > 0.2) {
          if (!elem.classList.contains("show-aniv-logo")) {
            elem.classList.add("show-aniv-logo");
          }
        } else {
          if (elem.classList.contains("show-aniv-logo")) {
            elem.classList.remove("show-aniv-logo");
          }
        }
    }

    window.addEventListener("scroll", () => {
        checkAnivLogo();
    });

    setTimeout(() => {  
        elem.classList.add("add-transition");
        setTimeout(() => {
            checkAnivLogo();
        }, 100);
    }, 600);

    
}
wus.runCommons = function() {
    this.handleAnnouncementBarLinks()
    wus.handleAccesoriesLink()
    wus.handleChatSupportPage()
    wus.handleProductsBIW()
    wus.handleLanguage()
    wus.handleStockChecked()
    wus.handleDisableVendorLink()
    wus.handleNewsletterButton()
    wus.fireScriptLazy()
    wus.handleFun()
    wus.handleLoyaltyButton()
    wus.handleWishList()
    wus.handleJQ()
    wus.handleLifestyleLink()
    wus.handleSearchPlaceholder()

    // wus.handleCheckoutFixTemp()

    wus.handleProductCounters();
    wus.handleEndlessCarousels();
    wus.handleAnivLogo();
    wus.handleRefundForms();
}

wus.handleFun = function() {
    wus.handleFunBoms()
}

wus.handleFunBoms = function() {
    var elems = document.querySelectorAll(".wus-fun-bom-container");
    for (var elem of elems) {
        wus.handleFunBom(elem);
        wus.handleFunBomScroll(elem);
    }

    document.addEventListener("scroll", function() {
        for (var elem of elems) {
            wus.handleFunBomScroll(elem);
        }
    });

    window.addEventListener('wheel', function(event) {
        for (var elem of elems) {
            wus.handleFunBomWheel(elem, event);
        }
    });

    window.addEventListener('keydown', function(event) {
        for (var elem of elems) {
            wus.handleFunBomKeydown(elem, event);
        }
    });

    document.addEventListener('touchstart', (event) => {
        startY = event.touches[0].clientY;
    });

    document.addEventListener('touchmove', (event) => {
        for (var elem of elems) {
            wus.handleFunBomTouchmove(elem, event);
        }
    });
}

wus.isRTL = function() {
    var isRTL = false;
    
    if (Shopify && Shopify.locale === "ar") {
        isRTL = true;
    }

    return isRTL;
}

wus.handleFunBom = function(elem) {
    var type = elem.getAttribute("data-type");
    
    if (type === "wus-fun-bom-type-trio") {
        wus.handleFunBomTrio(elem);
        return;
    }

    if (type === "wus-fun-bom-type-slideout") {
        wus.handleFunBomSlideout(elem);
        return;
    }

    if (type === "wus-fun-bom-type-vershow") {
        wus.handleFunVershow(elem);        
        return;
    }
}

wus.handleFunVershow = function(elem) {
    const headerElem = document.querySelector("header");
    const parent = elem.closest(".shopify-section--wus-fun-stuff");
    const mainElem = elem.querySelector(".wus-fun-vershow-main")
    const headerHeight = headerElem.clientHeight;

    const elemHeight = window.innerHeight - headerHeight;
    const hrefElem = elem.querySelector(".wus-fun-bom-link");
    const imagesShow = elem.querySelectorAll(".wus-fun-vershow-img");

    //const allContainerHeight = elemHeight * (imagesShow.length + (imagesShow.length / 2));
    const allContainerHeight = elemHeight * (imagesShow.length);

    elem.style["height"] = allContainerHeight + "px";
    
    hrefElem.style["height"] = elemHeight + "px";
    hrefElem.style["position"] = "sticky";
    hrefElem.style["top"] = headerHeight + "px";

    setTimeout(() => {
        elem.classList.add("ready");
    }, 300);

    wus.checkVershowFirstElem(elem);
}

wus.handleFunBomSlideout = function(elem) {
    var parent = elem.closest(".shopify-section--wus-fun-stuff");
    var imageElem = elem.querySelector(".wus-fun-bom-img-slideout");
    var textElem = elem.querySelector(".wus-fun-bom-text-container-slideout")

    var imageWidth = imageElem.clientWidth;
    var imageHeight = imageElem.clientHeight;

    let rect = elem.getBoundingClientRect();

    let imageLeftPercentage = 0.5;
    let imageTopPercentage = 0.5;

    let imageLeftPosition = rect.width * imageLeftPercentage;
    let imageTopPosition = rect.height * imageTopPercentage;

    imageElem.style["left"] = (imageLeftPosition) + "px";
    imageElem.style["top"] = (imageTopPosition) + "px";

    imageElem.style["margin-left"] = -(imageWidth / 2) + "px";
    imageElem.style["margin-top"] = -(imageHeight / 2) + "px";

    setTimeout(() => {
        elem.classList.add("ready");
    }, 300);
}

wus.handleFunBomTrio = function(elem) {
    var parent = elem.closest(".shopify-section--wus-fun-stuff")
    var targetImageOne = parent.querySelector(".wus-fun-bom-img-1")

    var imageOneWidth = targetImageOne.clientWidth
    let rect = elem.getBoundingClientRect();

    var targetImageOneLeft = 0.55
    var targetImageOneTop = 0.40

    if (wus.isRTL()) {
        targetImageOneLeft = 0.17
    }

    if (innerWidth > 1500) {
        targetImageOneLeft = 0.60

        if (wus.isRTL()) {
            targetImageOneLeft = 0.20
        }
    }

    if (innerWidth < 1000) {
        var leftPercentage = (rect.width / 2 - imageOneWidth / 2) / rect.width
        targetImageOneLeft = leftPercentage
        targetImageOneTop = 0.47
    }

    var targetImageTwoLeft = targetImageOneLeft - 0.11
    var targetImageTwoTop = targetImageOneTop + 0.08
    var targetImageThreeLeft = targetImageOneLeft + 0.11
    var targetImageThreeTop = targetImageOneTop - 0.08
    
    var targetImageTwo = parent.querySelector(".wus-fun-bom-img-2")
    var targetImageTree = parent.querySelector(".wus-fun-bom-img-3")
    
    //var isRTL = wus.isRTL()

    var isRTL = false
    
    targetImageOne.style[isRTL ? "right" : "left"] = (rect.width * targetImageOneLeft) + "px" 
    targetImageOne.style["top"] = (rect.height * targetImageOneTop) + "px" 

    targetImageTwo.style[isRTL ? "right" : "left"] = (rect.width * targetImageTwoLeft) + "px" 
    targetImageTwo.style["top"] = (rect.height * targetImageTwoTop) + "px" 

    targetImageTree.style[isRTL ? "right" : "left"] = (rect.width * targetImageThreeLeft) + "px" 
    targetImageTree.style["top"] = (rect.height * targetImageThreeTop) + "px" 

    setTimeout(() => {
        elem.classList.add("ready")
    }, 300);
}

wus.mapValues = function(value, in_min, in_max, out_min, out_max) {
    return ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
}

wus.handleFunBomScroll = function(elem) {
    var type = elem.getAttribute("data-type");
    
    if (type === "wus-fun-bom-type-trio") {
        wus.handleFunBomTrioScroll(elem);
        return;
    }

    if (type === "wus-fun-bom-type-slideout") {
        wus.handleFunBomSlideoutScroll(elem);
        return;
    }

    if (type === "wus-fun-bom-type-vershow") {
        wus.handleFunVershowScroll(elem);
        return;
    }
}

wus.handleFunBomWheel = function(elem, event) {
    var type = elem.getAttribute("data-type");

    if (type === "wus-fun-bom-type-vershow") {
        wus.handleFunVershowWheel(elem, event);
        return;
    }
}

wus.handleFunBomTouchmove = function(elem, event) {
    var type = elem.getAttribute("data-type");

    if (type === "wus-fun-bom-type-vershow") {
        wus.handleVershowTouchMove(elem, event);
        return;
    }
}

wus.handleVershowTouchMove = function(elem, event) {
    const currentY = event.touches[0].clientY;
    const deltaY = startY - currentY;

    if (!elem.classList.contains("vershow-active")) {
        return
    }

    if (deltaY < 0) {
        wus.handleFunVershowUpDown(elem, "u")
        return;
    }
    
    if (deltaY > 0) {
        wus.handleFunVershowUpDown(elem, "d")
        return;
    }

    startY = currentY;
}

wus.handleFunBomKeydown = function(elem, event) {
    var type = elem.getAttribute("data-type");

    if (type === "wus-fun-bom-type-vershow") {
        wus.handleFunVershowKeydown(elem, event);
        return;
    }
}

wus.handleFunVershowWheel = function(elem, event) {
    if (!elem.classList.contains("vershow-active")) {
        return
    }

    if (event.deltaY < 0) {
        wus.handleFunVershowUpDown(elem, "u")
        return;
    }
    
    if (event.deltaY > 0) {
        wus.handleFunVershowUpDown(elem, "d")
        return;
    }
}

wus.vershowMoving = false;

wus.handleFunVershowKeydown = function(elem, event) {
    if (!elem.classList.contains("vershow-active")) {
        return;
    }

    if (event.key === "ArrowUp") {
        wus.handleFunVershowUpDown(elem, "u")
        return;
    }

    if (event.key === "ArrowDown") {
        wus.handleFunVershowUpDown(elem, "d")
        return;
    }
}

wus.checkVershowFirstElem = function(elem) {
    let activeElem = elem.querySelector('.wus-fun-vershow-img[data-slide="main"]');
    
    if (activeElem) {
        return
    }

    let allImages = elem.querySelectorAll('.wus-fun-vershow-img');

    let newActiveElem = allImages.length > 0 ? allImages[0] : null;

    if (!newActiveElem) {
        return;
    }

    //wus.setFunVershowActive(newActiveElem, allImages, "d", elem);
    wus.setFunVershowActiveByIndex(elem, 1);
}

wus.isVershowChagning = false

wus.setFunVershowActiveByIndex = function(elem, newIndex) {
    if (wus.isVershowChagning) {
        return
    }

    wus.isVershowChagning = true;
    let allImages = elem.querySelectorAll('.wus-fun-vershow-img');
    let imageShows = elem.querySelectorAll(".wus-fun-vershow-img");

    var currentIndex = -1;

    for (var i = 0; i < imageShows.length; i++) {
        var imageShow = imageShows[i];
        if (imageShow.getAttribute("data-slide") === "main") {
            currentIndex = i;
            break;
        }
    }
    
    currentIndex = currentIndex + 1;

    if (newIndex === currentIndex) {
        wus.isVershowChagning = false;
        return;
    }

    const direction = newIndex > currentIndex ? "d" : "u";

    let newActiveElem = allImages[newIndex - 1];

    if (!newActiveElem) {
        wus.isVershowChagning = false;
        return;
    }

    wus.setFunVershowActive(newActiveElem, imageShows, direction, elem);
    wus.isVershowChagning = false;
}

wus.handleFunVershowUpDown = function(elem, direction) {
    if (wus.vershowMoving) {
        return;
    }

    wus.vershowMoving = true;

    setTimeout(function() {
        wus.vershowMoving = false;
    }, 2000);

    let imageShows = elem.querySelectorAll(".wus-fun-vershow-img");
    let activeElem = elem.querySelector('.wus-fun-vershow-img[data-slide="main"]');

    if (!activeElem) {
        return
    }

    let prevActive = activeElem.previousElementSibling;
    let afterActive = activeElem.nextElementSibling;
    let imageShowLength = imageShows.length;
    
    let newActiveElem = direction === "d" ? afterActive : prevActive;

    if (!newActiveElem) {
        //wus.enableScroll();
        wus.disableFunVershow(elem, direction);
        return;
    }

    wus.setFunVershowActive(newActiveElem, imageShows, direction, elem);
}

wus.setFunVershowActive = function(newActiveElem, imageShows, direction, elem) {
    if (!newActiveElem) {
        return;
    }

    let prevActive = newActiveElem.previousElementSibling;
    let afterActive = newActiveElem.nextElementSibling;

    newActiveElem.setAttribute("data-slide", "main")

    let textIndex = newActiveElem.getAttribute("data-text");
    let url = newActiveElem.getAttribute("data-url");

    //console.log(textIndex);
    //console.log(url);
    
    let hrefElem = elem.querySelector(".wus-fun-bom-link")
    hrefElem.setAttribute("href", url);

    let targetTextElem = elem.querySelector(`.wus-fun-vershow-text-active[data-text="${textIndex}"]`);

    let textElems = elem.querySelectorAll(".wus-fun-vershow-text-active");

    for (const textElem of textElems) {
        textElem.classList.remove("wus-fun-vershow-text-show");
    }

    targetTextElem.classList.add("wus-fun-vershow-text-show");

    setTimeout(function() {
        //targetTextElem.classList.add("wus-fun-vershow-text-show");
    }, 100)
    

    if (direction === "u") {
        while (afterActive) {
            if (afterActive.getAttribute("data-slide") === "main") {
                afterActive.setAttribute("data-slide", "before");
            } else if (afterActive.getAttribute("data-slide") === "nono") {
                afterActive.setAttribute("data-slide", "sub");
            }

            afterActive = afterActive.nextElementSibling
        }

        if (prevActive) {
            prevActive.setAttribute("data-slide", "sub")
        }
    } else {
        while (prevActive) {
            if (prevActive.getAttribute("data-slide") === "main") {
                prevActive.setAttribute("data-slide", "sub");
            } else if (prevActive.getAttribute("data-slide") === "sub") {
                prevActive.setAttribute("data-slide", "nono");
            }

            prevActive = prevActive.previousElementSibling
        }

        if (afterActive) {
            afterActive.setAttribute("data-slide", "before")
        }
    }
}

wus.handleFunBomSlideoutScroll = function(elem) {
    let rect = elem.getBoundingClientRect();
    var parent = elem.closest(".shopify-section--wus-fun-stuff")
    let headerHeight = document.querySelector("header").clientHeight
    const actualScrollFromBottom = (rect.top) - (window.innerHeight)
    var imageElem = elem.querySelector(".wus-fun-bom-img-slideout");
    var textElem = elem.querySelector(".wus-fun-bom-text-container-slideout")

    if (actualScrollFromBottom > 0) {
        return
    }

    const scrollValueInsideDiv = actualScrollFromBottom * -1;
    const scrollInsidePercentage = (scrollValueInsideDiv / (rect.height + headerHeight)) * 100

    let minActionPercentage = 50;
    let maxActionPercentage = 100;

    if (window.innerWidth < 999) {
        minActionPercentage = 70;
        maxActionPercentage = 110;
    }

    let isRTL = false;

    if (scrollInsidePercentage >= minActionPercentage && scrollInsidePercentage <= maxActionPercentage) {
        let activePercentage = wus.mapValues(scrollInsidePercentage, minActionPercentage, maxActionPercentage, 0, 100);
        let distancePercX = -0.5;
        let distancePercY = 0.1;
        let targetScale = 0.9;

        if (window.innerWidth < 999) {
            distancePercX = -0;
            distancePercY = 0.4;
            targetScale = 0.9;
        }

        if (window.innerWidth < 699) {
            distancePercX = -0;
            distancePercY = 0.50;
            targetScale = 0.95;
        }
        
        const imageLeft = parseInt(imageElem.style[isRTL ? "right" : "left"]);
        const imageTop = parseInt(imageElem.style["top"]);
        const travelDistanceX = imageLeft * distancePercX;
        const travelDistanceY = imageTop * distancePercY;
        
        const percDec = activePercentage / 100;

        const translateX = travelDistanceX * percDec;
        const translateY = travelDistanceY * percDec;

        const imageScale = wus.mapValues(percDec, 0, 1, 1, targetScale);
        const textScale = wus.mapValues(percDec, 0, 1, 0, 1);
        const textOpacity = wus.mapValues(percDec, 0, 1, 0, 1);

        imageElem.style.transform = `translate(${translateX}px, ${translateY}px) scale(${imageScale})`;
        textElem.style.transform = `scale(${textScale})`;
        textElem.style.opacity = textOpacity;
    }
}

wus.handleFunBomTrioScroll = function(elem) {
    let rect = elem.getBoundingClientRect();
    var parent = elem.closest(".shopify-section--wus-fun-stuff")
    let headerHeight = document.querySelector("header").clientHeight
    const actualScrollFromBottom = (rect.top) - (window.innerHeight)

    var targetImageOne = parent.querySelector(".wus-fun-bom-img-1")
    var targetImageTwo = parent.querySelector(".wus-fun-bom-img-2")
    var targetImageThree = parent.querySelector(".wus-fun-bom-img-3")

    if (actualScrollFromBottom > 0) {
        return
    }

    const scrollValueInsideDiv = actualScrollFromBottom * -1;
    const scrollInsidePercentage = (scrollValueInsideDiv / (rect.height + headerHeight)) * 100

    const minActionPercentage = 60;
    const maxActionPercentage = 180;

    //var isRTL = wus.isRTL()
    var isRTL = false;

    if (scrollInsidePercentage >= minActionPercentage && scrollInsidePercentage <= maxActionPercentage) {
        let activePercentage = wus.mapValues(scrollInsidePercentage, minActionPercentage, maxActionPercentage, 0, 100);

        const imageOneLeft = parseInt(targetImageOne.style[isRTL ? "right" : "left"]);
        const imageOneTop = parseInt(targetImageOne.style["top"]);
        const imageTwoLeft = parseInt(targetImageTwo.style[isRTL ? "right" : "left"]);
        const imageTwoTop = parseInt(targetImageTwo.style["top"]);
        const imageThreeLeft = parseInt(targetImageThree.style[isRTL ? "right" : "left"]);
        const imageThreeTop = parseInt(targetImageThree.style["top"]);

        const overshootFactorTwo = 2.5;
        const overshootFactorTree = 2.5;

        const directionTwoX = imageOneLeft - imageTwoLeft;
        const directionTwoY = imageOneTop - imageTwoTop;
        const directionThreeX = imageOneLeft - imageThreeLeft;
        const directionThreeY = imageOneTop - imageThreeTop;

        const futureTwoX = imageTwoLeft + directionTwoX * overshootFactorTwo;
        const futureTwoY = imageTwoTop + directionTwoY * overshootFactorTwo;
        const futureThreeX = imageThreeLeft + directionThreeX * overshootFactorTree;
        const futureThreeY = imageThreeTop + directionThreeY * overshootFactorTree;

        const distanceTwoX = futureTwoX - imageTwoLeft
        const distanceTwoY = futureTwoY - imageTwoTop
        const distanceThreeX = futureThreeX - imageThreeLeft
        const distanceThreeY = futureThreeY - imageThreeTop

        const translateTwoX = distanceTwoX * (activePercentage / 100);
        const translateTwoY = distanceTwoY * (activePercentage / 100);
        const translateThreeX = distanceThreeX * (activePercentage / 100);
        const translateThreeY = distanceThreeY * (activePercentage / 100);

        targetImageTwo.style.transform = `translate(${translateTwoX}px, ${translateTwoY}px) rotate(15deg)`;
        targetImageThree.style.transform = `translate(${translateThreeX}px, ${translateThreeY}px) rotate(15deg)`;
    }
}

wus.disableVerShowScroll = false;
wus.prevVershowIndex = -1;
wus.currentVershowIndex = -1;

wus.handleFunVershowScroll2 = function(elem) {
    const imagesShow = elem.querySelectorAll(".wus-fun-vershow-img");
    const number = imagesShow.length;
    
    const calculateSegments = () => {
        const rect = elem.getBoundingClientRect();
        const divTop = window.scrollY + rect.top;
        const divHeight = rect.height;
        const segmentHeight = divHeight / number;
  
        return Array.from({ length: number }, (_, i) => ({
            start: divTop + i * segmentHeight,
            end: divTop + (i + 1) * segmentHeight,
            index: i + 1,
        }));
    };

    const checkScrollPosition = () => {
        const rect = elem.getBoundingClientRect();
        const elemTop = window.scrollY + rect.top;
        const elemBottom = elemTop + rect.height;

        const scrollTop = window.scrollY;

        if (scrollTop + window.innerHeight < elemTop) {
            return "before";
        } else if (scrollTop > elemBottom) {
            return "after";
        } else {
            return "inside";
        }
    };

    const scrollStatus = checkScrollPosition();

    const scrollPos = window.scrollY + window.innerHeight / 2;
    const segments = calculateSegments();

    if (scrollStatus === "before") {
        wus.setFunVershowActiveByIndex(elem, 1);
    } else if (scrollStatus === "after") {
        wus.setFunVershowActiveByIndex(elem, number);
    } else {
        segments.forEach(segment => {
            if (scrollPos >= segment.start && scrollPos < segment.end) {
                wus.setFunVershowActiveByIndex(elem, segment.index);
            }
        });
    }
}

wus.handleFunVershowScroll = function(elem) {
    wus.handleFunVershowScroll2(elem);
    return;
    if (wus.disableVerShowScroll) {
        return;
    }

    let rect = elem.getBoundingClientRect();
    var parent = elem.closest(".shopify-section--wus-fun-stuff")
    let headerHeight = document.querySelector("header").clientHeight

    let currentDivTop = rect.top - headerHeight;
    
    console.log(currentDivTop, rect.height / 2);

    if (currentDivTop <= 50 && currentDivTop > -rect.height) {
        //wus.disableVerShowScroll = true;
        //wus.handleFunVershowInside(elem);
    }
}

wus.disableFunVershow = function(elem, direction) {
    let rect = elem.getBoundingClientRect();
    let headerHeight = document.querySelector("header").clientHeight;
    let scrollPosition = (window.scrollY + rect.top - headerHeight) + rect.height;
    
    if (direction === "u") {
        scrollPosition = window.scrollY - rect.height;
    }

    wus.disableVerShowScroll = true;

    window.scrollTo({ top: scrollPosition, behavior: "smooth" });

    elem.classList.remove("vershow-active");

    setTimeout(function() {
        wus.disableVerShowScroll = false;
        wus.enableScroll();
    }, 1000)
}

wus.handleFunVershowInside = function(elem) {
    if (elem.classList.contains("vershow-active")) {
        //return;
    }

    wus.disableScroll();

    let rect = elem.getBoundingClientRect();
    var parent = elem.closest(".shopify-section--wus-fun-stuff");
    let headerHeight = document.querySelector("header").clientHeight;
    const scrollPosition = window.scrollY + rect.top - headerHeight;
    
    window.scrollTo({ top: scrollPosition, behavior: "smooth" });
    setTimeout(function() {
        elem.classList.add("vershow-active");
    }, 1000);
}

wus.disableScroll = function() {
    window.addEventListener('touchstart', wus.preventDefault, { passive: false });
    window.addEventListener('wheel', wus.preventDefault, { passive: false });
    window.addEventListener('keydown', wus.preventArrowKeys, { passive: false });
    if (wus.isMobileScreen()) {
        document.body.style["overflow"] = "hidden"
    }
}

wus.enableScroll = function() {
    window.removeEventListener('touchstart', wus.preventDefault);
    window.removeEventListener('wheel', wus.preventDefault);
    window.removeEventListener('keydown', wus.preventArrowKeys);
    if (wus.isMobileScreen()) {
        document.body.style["overflow"] = "auto"
    }
}

wus.preventDefault = function(event) {
    event.preventDefault();
}

wus.preventArrowKeys = function(event) {
    const keys = ['ArrowUp', 'ArrowDown'];
    if (keys.includes(event.key)) {
        event.preventDefault();
    }
}

wus.execLazyLoadingScript = function() {
    wus.showNewsletterButton()
}

wus.isCustomerConnected = function() {
    if (typeof window.WUS_CUSTOMER_EMAIL === "string") {
        return true;
    }

    return false;
}

wus.handleLoyaltyButton = function() {
    if (wus.isProductPage()) {
        return;
    }

    var buttonElem = document.getElementById("dsquaresIframeToggleButton");
    if (!buttonElem) {
        setTimeout(function() {
            wus.handleLoyaltyButton();
        }, 200);
        
        return;
    }

    function createOverlay() {
        const overlayDiv = document.createElement("div");
        overlayDiv.id = "dsq-overlay";

        document.body.appendChild(overlayDiv);

        overlayDiv.onclick = function() {
            const encodedRedirectPath = encodeURIComponent("/?open_loy=1");
            const loginPath = `/customer_authentication/login?return_to=${encodedRedirectPath}`;
            window.location.href = loginPath;
        }
    }

    function checkOpenDSQ() {
        const url = new URL(window.location.href);
        if (url.searchParams.has("open_loy")) {
            url.searchParams.delete("open_loy");
            buttonElem.click();
            window.history.replaceState({}, "", url);
        }
    }

    if (!wus.isCustomerConnected()) {
        createOverlay();
    } else {
        checkOpenDSQ();
    }
}

wus.handleSizeChart = function() {
    var sizeChartElem = document.querySelector('[id^="size-chart-"]');
    
    if (!sizeChartElem) {
        return;
    }

    var overflowContent = sizeChartElem.shadowRoot?.querySelector('[part="body"]')

    var zoomableDiv = sizeChartElem.querySelector(".prose");

    if (!zoomableDiv) {
        return;
    }

    const images = zoomableDiv.querySelectorAll('img');

    images.forEach((img) => {
        img.style.width = `100%`;
        img.style["max-width"] = `none`;
    });

    let lastTouches = [];
    let currentWidthPercentage = 100;

    const minPercentage = 100;
    const maxPercentage = 200;

    function getDistance(touch1, touch2) {
        const dx = touch1.clientX - touch2.clientX;
        const dy = touch1.clientY - touch2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }

    function getCenter(touch1, touch2) {
        return {
            x: (touch1.clientX + touch2.clientX) / 2,
            y: (touch1.clientY + touch2.clientY) / 2
        };
    }

    zoomableDiv.addEventListener('touchstart', (event) => {
        if (event.touches.length === 2) {
            lastTouches = [event.touches[0], event.touches[1]];
        }
    });

    zoomableDiv.addEventListener('touchmove', (event) => {
        if (event.touches.length === 2) {
            event.preventDefault();
            const currentTouches = [event.touches[0], event.touches[1]];
            const initialDistance = getDistance(lastTouches[0], lastTouches[1]);
            const currentDistance = getDistance(currentTouches[0], currentTouches[1]);
            const zoomFactor = currentDistance / initialDistance;

            let newWidthPercentage = currentWidthPercentage * zoomFactor;

            newWidthPercentage = Math.max(minPercentage, Math.min(maxPercentage, newWidthPercentage));

            const center = getCenter(currentTouches[0], currentTouches[1]);

            const offsetX = (center.x + overflowContent.scrollLeft) / overflowContent.offsetWidth;
            const offsetY = (center.y + overflowContent.scrollTop) / overflowContent.offsetHeight;

            images.forEach((img) => {
                img.style.width = `${newWidthPercentage}%`;
            });

            const newScrollLeft = offsetX * overflowContent.scrollWidth - center.x;
            const newScrollTop = offsetY * overflowContent.scrollHeight - center.y;

            // overflowContent.scrollLeft = newScrollLeft;
            // overflowContent.scrollTop = newScrollTop;

            currentWidthPercentage = newWidthPercentage;
            lastTouches = currentTouches;
        }
    });

    zoomableDiv.addEventListener('touchend', () => {
        lastTouches = [];
    });
}

wus.fireScriptLazy = function() {
    var lazyLoadStarted = false

    document.addEventListener("click", startLazyLoad);
    document.addEventListener("scroll", startLazyLoad);
    document.addEventListener("touchstart", startLazyLoad);
    document.addEventListener("mousemove", startLazyLoad);

    function startLazyLoad() {
        if (lazyLoadStarted) {
            return
        }

        lazyLoadStarted = true

        setTimeout(function() {
            wus.execLazyLoadingScript()
        }, 100)
    }
}

wus.fire = function() {
    this.run()
}

wus.isProductPage = function() {
    return meta.page && meta.page.pageType === "product"
}

wus.isCollectionPage = function() {
    return meta.page && meta.page.pageType === "collection"
}

wus.isHomePage = function() {
    return meta.page && meta.page.pageType === "home"
}

wus.addProductPageClass = function() {
    document.body.classList.add("wus-product-page")
}

wus.runCollectionPage = function() {
    if (!wus.isCollectionPage()) {
        return
    }

    wus.handleFlashSaleCounterCollection();
}

wus.handleWishList = function() {
    window.variant_name_id_selector = '[name=id]'
    window.custom_variant_change = '.shopify-product-form [name=id]'
    window.iwish_qvWrapper = '.quick-buy-drawer.show-close-cursor'
    
    function handleWishListButton() {
        var buttonElem = document.querySelector(".wus-wishtlist-icon");
        var headerButtonElem = document.querySelector("#wus-wishlist-selector-mobile");
        var iWishButtonElem = document.querySelector(".iwish-float-icon");

        if (!headerButtonElem || !buttonElem) {
            setTimeout(function() {
                handleWishListButton();
            }, 200);
            return;
        }

        buttonElem.addEventListener("click", function(e) {
            e.preventDefault();
            iWishButtonElem.click();
        })

        headerButtonElem.addEventListener("click", function(e) {
            e.preventDefault();
            iWishButtonElem.click();
        })
    }

    function observeWishListCounter() {
        var iWishCounterElem = document.querySelector(".iwish-counter");
        var wusWishListCountElem = document.querySelector(".wus-wishlist-count");
        var wusWishListHeaderCountElem = document.querySelector(".wus-wishlist-header-count");

        if (!iWishCounterElem || !wusWishListCountElem || !wusWishListHeaderCountElem) {
            setTimeout(function() {
                observeWishListCounter();
            }, 200);
            return;
        }

        function updateWishlistCounts() {
            var tc = iWishCounterElem?.textContent?.trim()

            if (typeof tc !== "string" || tc === "") {
                return
            }

            if (isNaN(tc)) {
                return
            }

            var tcn = parseInt(tc);

            if (tcn <= 0) {
                tcn = 0;
                localStorage.setItem("iWishCnt", "0");
                showHideWishlistButton("h");
            } else {
                showHideWishlistButton("s");
            }

            wusWishListCountElem.textContent = iWishCounterElem.textContent.trim();
            wusWishListHeaderCountElem.innerHTML = iWishCounterElem.textContent.trim();
        }

        var observer = new MutationObserver(function(mutationsList) {
            for (var mutation of mutationsList) {
                if (mutation.type === "characterData" || mutation.type === "childList") {
                    updateWishlistCounts()
                }
            }
        });

        observer.observe(iWishCounterElem, { characterData: true, childList: true, subtree: true });

        setTimeout(function() {
            updateWishlistCounts()
        }, 100);
    }

    function observeDrawerState() {
        const drawerElem = document.querySelector("#mst-iwish-drawer-root .react-side-draw");
    
        if (!drawerElem) {
            setTimeout(function() {
                observeDrawerState();
            }, 200);
            return;
        }
    
        function checkDrawerState() {
            if (!drawerElem.classList.contains("open")) {
                setTimeout(function() {
                    updateCartHeaderCount()
                }, 1500);
            }
        }
    
        const observer = new MutationObserver(() => {
            checkDrawerState();
        });
    
        observer.observe(drawerElem, { attributes: true, attributeFilter: ["class"] });
    
        checkDrawerState();
    }

    function updateCartHeaderCount() {
        var headerCountElem = document.querySelector(".header__cart-count cart-count.count-bubble");
        var cartCountElem = document.querySelector(".cart-drawer__inner cart-count.count-bubble");

        if (!headerCountElem || !cartCountElem) {
            return;
        }

        if (isNaN(cartCountElem.innerHTML)) {
            return
        }

        let count = parseInt(cartCountElem.innerHTML);

        headerCountElem.itemCount = count;
    }

    function showHideWishlistButton(type) {
        var elem = document.querySelector(".wus-wishtlist-icon");
        var elemHeader = document.querySelector(".wus-wishlist-header-count");

        if (!elem || !elemHeader) {
            return;
        }

        if (type === "s") {
            elemHeader.style["opacity"] = "1"
            elem.style["display"] = "block"
            setTimeout(function() {
                elem.style["opacity"] = "1"
            }, 20);
            
        } else {
            elemHeader.style["opacity"] = "0"
            elem.style["opacity"] = "0"
            setTimeout(function() {
                elem.style["display"] = "none"
            }, 450);
        }
    }

    function observeProductPageWishList() {
        const addWishlistButton = document.querySelector(".product-info .iwish-app-block-wrapper .iWishAdd");
        const wusProductWishAddImage = document.querySelector("product-gallery .wus-wishlist-product-image")
        if (!addWishlistButton || !wusProductWishAddImage) {
            setTimeout(function() {
                observeProductPageWishList();
            }, 200);
            return;
        }
    
        function checkWishButtonClass() {
            if (addWishlistButton.classList.contains("iwishAdded")) {
                wusProductWishAddImage.classList.add("added");
            } else {
                wusProductWishAddImage.classList.remove("added");
            }
        }
    
        const observer = new MutationObserver(() => {
            checkWishButtonClass();
        });
    
        observer.observe(addWishlistButton, { attributes: true, attributeFilter: ["class"] });
    
        checkWishButtonClass();
    }

    function handleWishListProductPageAdd() {
        const addWishlistButton = document.querySelector(".product-info .iwish-app-block-wrapper .iWishAdd");
        const wusProductWishAddImage = document.querySelector("product-gallery .wus-wishlist-product-image")
       
        if (!addWishlistButton || !wusProductWishAddImage) {
            setTimeout(function() {
                handleWishListProductPageAdd();
            }, 200);
            return;
        }

        wusProductWishAddImage.addEventListener("click", function(e) {
            e.preventDefault();
            addWishlistButton.click();
        })
    }

    if (wus.isProductPage()) {
        observeProductPageWishList()
        handleWishListProductPageAdd()
    }

    handleWishListButton();
    observeWishListCounter();
    observeDrawerState();
}

wus.handleJQ = function() {
    if (!window.jQuery) {
        setTimeout(function() {
            wus.handleJQ();
        }, 200);
        return;
    }

    window.$ = window.jQuery;
}

wus.runProductPage = function() {
    if (!wus.isProductPage()) {
        return
    }

    wus.addProductPageClass()
    wus.handleSizeChart()
}

wus.startCountdown = function(element, startHour, startMinute, durationMinutes, beforeStart, onStart, onEnd) {
    let now = new Date();
    let startTime = new Date();
    startTime.setHours(startHour, startMinute, 0, 0);
    
    let endTime = new Date(startTime.getTime() + durationMinutes * 60 * 1000);
    
    if (now > endTime) {
        startTime.setDate(startTime.getDate() + 1);
        endTime.setDate(endTime.getDate() + 1);
    }

    console.log(startTime);
    
    let hasStarted = false;
    let beforeStartCalled = false;
    
    function updateCountdown() {
        let currentTime = new Date();
        
        if (currentTime < startTime) {
            element.innerText = "Countdown not started yet";
            if (!beforeStartCalled && typeof beforeStart === "function") {
                beforeStart();
                beforeStartCalled = true;
            }
            return;
        }
        
        if (!hasStarted) {
            hasStarted = true;
            if (typeof onStart === "function") {
                onStart();
            }
        }
        
        let timeLeft = endTime - currentTime;
        
        if (timeLeft <= 0) {
            element.innerText = "00:00:00";
            clearInterval(interval);
            if (typeof onEnd === "function") {
                onEnd();
            }
            return;
        }
        
        let hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
        let minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
        let seconds = Math.floor((timeLeft / 1000) % 60);
        
        element.innerText = 
            String(hours).padStart(2, '0') + ":" + 
            String(minutes).padStart(2, '0') + ":" + 
            String(seconds).padStart(2, '0');
    }
    
    let interval = setInterval(updateCountdown, 1000);
    updateCountdown();
}

wus.startCountdownUntil = function(element, endHour, endMinute, onEnd) {
    let now = new Date();

    let endTime = new Date();
    endTime.setHours(endHour, endMinute, 0, 0);

    if (now >= endTime) {
        endTime.setDate(endTime.getDate() + 1);
    }

    function updateCountdown() {
        let currentTime = new Date();
        let timeLeft = endTime - currentTime;

        if (timeLeft <= 0) {
            element.innerText = "00:00:00";
            clearInterval(interval);
            if (typeof onEnd === "function") {
                onEnd();
            }
            return;
        }

        let hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
        let minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
        let seconds = Math.floor((timeLeft / 1000) % 60);

        element.innerText =
            String(hours).padStart(2, '0') + ":" +
            String(minutes).padStart(2, '0') + ":" +
            String(seconds).padStart(2, '0');
    }

    let interval = setInterval(updateCountdown, 1000);
    updateCountdown();
}

wus.startCountdownUntilDate = function(element, endDate, onStart, onEnd) {
    let now = new Date();

    let hasStarted = false;

    let endTime = endDate;

    if (!isValidDateWUS(endTime)) {
        return;
    }

    function updateCountdown() {
        let currentTime = new Date();
        let timeLeft = endTime - currentTime;

        if (timeLeft <= 0) {
            element.innerText = "00:00:00";
            clearInterval(interval);
            if (typeof onEnd === "function") {
                onEnd();
            }
            return;
        }

        if (!hasStarted) {
            hasStarted = true;
            if (typeof onStart === "function") {
                onStart();
            }
        }

        let hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
        let minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
        let seconds = Math.floor((timeLeft / 1000) % 60);

        element.innerText =
            String(hours).padStart(2, '0') + " : " +
            String(minutes).padStart(2, '0') + " : " +
            String(seconds).padStart(2, '0');
    }

    let interval = setInterval(updateCountdown, 1000);
    updateCountdown();
}

wus.runCountdownUntilDate = function(element, endDate, onStart, onEnd) {
    let hasStarted = false;

    let endTime = endDate;

    if (!isValidDateWUS(endTime)) {
        return;
    }

    if (element.classList.contains("running")) {
        return;
    }

    const hoursElem = element.querySelector(".wus-product-countdown-timer-hours");
    const minutesElem = element.querySelector(".wus-product-countdown-timer-minutes");
    const secondsElem = element.querySelector(".wus-product-countdown-timer-seconds");

    function updateCountdown() {
        let currentTime = new Date();
        let timeLeft = endTime - currentTime;

        if (timeLeft <= 0) {
            hoursElem.innerText = "00";
            minutesElem.innerText = "00";
            secondsElem.innerText = "00";
            clearInterval(interval);
            element.classList.remove("running");
            if (typeof onEnd === "function") {
                onEnd();
            }
            return;
        }

        if (!hasStarted) {
            hasStarted = true;
            element.classList.add("running");
            if (typeof onStart === "function") {
                onStart();
            }
        }

        let hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
        let minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
        let seconds = Math.floor((timeLeft / 1000) % 60);

        hoursElem.innerText = String(hours).padStart(2, '0');
        minutesElem.innerText = String(minutes).padStart(2, '0');
        secondsElem.innerText = String(seconds).padStart(2, '0');
    }

    let interval = setInterval(updateCountdown, 1000);
    updateCountdown();
}


wus.handleFlashSaleCounterCollection = function() {
    if (!window.location.href.includes("flash-sale")) {
        return;
    }

    let counterElem = document.querySelector(".flash-sale-counter");

    if (!counterElem) {
        setTimeout(function() {
            wus.handleFlashSaleCounterCollection();
        }, 200);
        return;
    }

    wus.startCountdownUntil(counterElem, 21, 0);
}

wus.handleLifestyleLink = function() {
    if (!wus.isMobileScreen()) {
        return
    }

    var imageBase = "https://cdn.shopify.com/s/files/1/0413/0416/2471/files/lifestyle_circle_3.gif?v=1743259768"

    var sideMenuElem = document.querySelector("#header-sidebar-menu")
    if (!sideMenuElem) {
        setTimeout(function() {
            wus.handleLifestyleLink()
        }, 100)
        return
    }

    function handleMenuOpenClose() {
        if (sideMenuElem.classList.contains("show-close-cursor")) {
            setTimeout(function() {
                setLS()
            }, 0);
            
        } else {
            removeLS()
        }
    }

    function iniLS() {
        var elem = document.querySelector("#header-sidebar-menu a[href*=lifestyle]");
        if (!elem) {
            return
        }

        const newImg = document.createElement('img');

        newImg.src = imageBase;
        newImg.id = 'ls-circle';

        elem.prepend(newImg);
        newImg.style.opacity = 0;
    }

    function setLS() {
        var elem = document.querySelector("#header-sidebar-menu a[href*=lifestyle]");
        if (!elem) {
            return
        }

        const img = document.querySelector("#ls-circle");

        if (img) {
            let randomNumber = Math.floor(Math.random() * 1000000);
            img.src = imageBase + '#' + randomNumber;
            img.onload = function() {
                setTimeout(function() {
                    img.style.opacity = 1;
                }, 200);
            }

            return;
        }

    }

    function removeLS() {
        var elem = document.querySelector("#header-sidebar-menu a[href*=lifestyle]");
        if (!elem) {
            return
        }

        const img = document.querySelector("#ls-circle");
        if (img) {
            img.style.opacity = 0;
        }
    }

    const observer = new MutationObserver(() => {
        handleMenuOpenClose();
    });

    observer.observe(sideMenuElem, { attributes: true, attributeFilter: ["class"] });

    handleMenuOpenClose();

    iniLS();
}

wus.handleLastPieces = function() {
    if (wus.isHomePage()) {
        return;
    }
    
    if (!window.location.href.includes("collections/last-pieces")) {
        return;
    }

    var imageBase = "https://cdn.shopify.com/s/files/1/0413/0416/2471/files/lifestyle_circle_3.gif?v=1743259768"

    if (!wus.isMobileScreen()) {
        var filterElem = document.querySelector(".collection__facets #accordion-filter-v-option-size")

        if (!filterElem) {
            return;
        }

        filterElem.style.position = "relative";

        const summaryElem = filterElem.querySelector("summary");

        if (!summaryElem) {
            return;
        }

        const newImg = document.createElement('img');

        newImg.src = imageBase;
        newImg.classList.add("last-pieces-circle");
        newImg.style.opacity = 0;

        filterElem.prepend(newImg);

        setTimeout(function() {
            newImg.style.opacity = 1;
        }, 200);
        
    } else {

    }
}

wus.handleFlashSaleCounter = function() {
    let mainElem = document.querySelector("#shopify-section-template--19135002804462__slideshow_FDz68L");

    if (!mainElem) {
        setTimeout(function() {
            wus.handleFlashSaleCounter();
        }, 200);
        return;
    }

    let flashSaleCounterDiv = document.createElement("div");
    flashSaleCounterDiv.classList.add("counter-flash-sale");
    flashSaleCounterDiv.innerHTML = "00:00:00";
    mainElem.appendChild(flashSaleCounterDiv);

    wus.startCountdown(flashSaleCounterDiv, 21, 0, 180, function() {
        mainElem.style.display = "none";
    }, function() {
        mainElem.style.display = "block";
    }, function() {
        mainElem.style.display = "none";
    });
}

wus.handleCheckoutFixTemp = function() {
    var currentHref = window.location.href;

    if (currentHref.includes("checkout")) {
        return;
    }
    
    deleteLocalStorageKeyWUS("__ui");
}

wus.runHomePage = function() {
    if (!wus.isHomePage()) {
        return
    }

    wus.handleFlashSaleCounter()
}

wus.handleProductCounters = function() {
    function run() {
        let productCounters = document.querySelectorAll(".wus-product-countdown");

        if (!productCounters) {
            return;
        }
        
        productCounters.forEach(function(counter) {
            let dateEnd = counter.getAttribute("data-date-end");
            
            var dateToEnd = new Date(dateEnd);

            if (!isValidDateWUS(dateToEnd)) {
                return;
            }

            wus.runCountdownUntilDate(counter, dateToEnd, function() {
                counter.classList.add("show");
            }, function() {
                counter.classList.remove("show");
            });
        });
    }

    run();

    setInterval(run, 2000);
}

wus.handleRefundForms = function() {
    if (!window.location.href.includes("pages/refund-request")) {
        // return;
    }

    let refundForms = document.querySelectorAll(".wus-refund-request-form");

    if (!refundForms) {
        return;
    }
    
    function messageAndRefresh(message) {
        alert(message);
        setTimeout(function() {
            window.location.reload();
        }, 1000);
    }

    function handleRefundMethodChange(form) {
        let refundMethod = form.querySelector("select[name='contact[refundMethod]']");

        if (!refundMethod) {
            return;
        }

        refundMethod.addEventListener("change", function() {
            let refundMethodValue = refundMethod.value;

            let walletContainer = form.querySelector(".wus-refund-request-wallet-number-container");
            let bankContainer = form.querySelector(".wus-refund-request-wallet-bank-container");

            let bankInput = form.querySelector("[name='contact[bank]']");
            let accountNumberInput = form.querySelector("[name='contact[accountNumber]']");
            let walletNumberInput = form.querySelector("[name='contact[walletNumber]']");
            let walletAccountNameInput = form.querySelector("[name='contact[walletAccountName]']");
            let bankAccountNameInput = form.querySelector("[name='contact[bankAccountName]']");
            
            if (refundMethodValue === "Bank") {
                bankContainer.style.display = "grid";
                walletContainer.style.display = "none";

                bankInput.setAttribute("required", "required");
                accountNumberInput.setAttribute("required", "required");
                bankAccountNameInput.setAttribute("required", "required");
                walletNumberInput.removeAttribute("required");
                walletAccountNameInput.removeAttribute("required");
                
            } else if (refundMethodValue === "Wallet") {
                bankContainer.style.display = "none";
                walletContainer.style.display = "grid";

                bankInput.removeAttribute("required");
                accountNumberInput.removeAttribute("required");
                bankAccountNameInput.removeAttribute("required");
                walletNumberInput.setAttribute("required", "required");
                walletAccountNameInput.setAttribute("required", "required");
            } else {
                bankContainer.style.display = "none";
                walletContainer.style.display = "none";

                bankInput.removeAttribute("required");
                accountNumberInput.removeAttribute("required");
                walletNumberInput.removeAttribute("required");
            }
        });
    }

    function handleRefundForm(form) {
        const successMessage = form.querySelector(".wus-success-message");
        const errorMessage = form.querySelector(".wus-error-message");

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            let scriptURL = form.getAttribute("action");

            const formData = new FormData(form);
        
            fetch(scriptURL, {
              method: 'POST',
              body: formData
            })
            .then(response => response.json())
            .then(data => {
              if (data.result === 'success') {
                form.reset();
                messageAndRefresh(successMessage.textContent);
              } else {
                messageAndRefresh(errorMessage.textContent);
              }
            })
            .catch(error => {
              messageAndRefresh(errorMessage.textContent);
            });
        });
    }

    refundForms.forEach(function(form) {
        handleRefundForm(form);
        handleRefundMethodChange(form);
    });
}

wus.run = function() {
    if (!this.canRun()) {
        setTimeout(function() {
            wus.run()
        }, 100)

        return
    }
    
    wus.runCommons()
    wus.runProductPage()
    wus.runHomePage()
    wus.runCollectionPage()
}

wus.fire()